// src/pages/WarzoneRosterPage.jsx
import { useState } from "react";
import { Link } from "react-router-dom";
import { usePlayersByGroup } from "../hooks/usePlayers";
import RosterSkeleton from "../components/RosterSkeleton";
import PlayerPhoto from "../components/PlayerPhoto";

import WarzoneHero from "../assets/divisions/warzone.jpeg";

const tabs = ["All", "Warzone", "Warzone Substitute"];

function WarzoneRosterPage() {
  const [activeTab, setActiveTab] = useState("All");
  const { players: warzonePlayers, loading } = usePlayersByGroup("warzone");

  const filtered =
    activeTab === "All"
      ? warzonePlayers
      : warzonePlayers.filter((p) => p.division === activeTab);

  return (
    <main className="bg-black min-h-screen">
      {/* Hero */}
      <section className="relative h-[50vh] min-h-[400px] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src={WarzoneHero}
            alt="Warzone Division"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/40"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-red-900/20 to-transparent"></div>
        </div>
        <div className="relative z-10 text-center px-6">
          <span className="text-red-500 text-sm font-semibold uppercase tracking-wider mb-2 block">
            Battle Royale / Resurgence
          </span>
          <h1 className="text-5xl md:text-7xl font-black uppercase tracking-tight text-white mb-4">
            Warzone <span className="text-red-600">Roster</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Our Battle Royale and Resurgence roster representing the Caribbean on the Warzone scene
          </p>
          <Link
            to="/roster"
            className="inline-flex items-center gap-2 mt-6 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Teams
          </Link>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="px-6 pt-8 pb-4">
        <div className="max-w-6xl mx-auto">
          <div className="flex gap-2 flex-wrap">
            {tabs.map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-5 py-2 text-sm font-bold uppercase tracking-wide rounded transition-colors ${
                  activeTab === tab
                    ? "bg-red-600 text-white"
                    : "bg-gray-900 text-gray-400 hover:text-white border border-gray-800"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Roster Grid */}
      <section className="px-6 pb-24 pt-4">
        <div className="max-w-6xl mx-auto">
          {loading ? (
            <RosterSkeleton count={4} />
          ) : filtered.length === 0 ? (
            <p className="text-gray-500 text-center py-16">No players found.</p>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
              {filtered.map((player) => (
                <Link
                  key={player.id}
                  to={`/roster/${player.id}`}
                  className="group bg-gray-900 border border-gray-800 rounded-lg overflow-hidden hover:border-red-600/50 transition-all duration-300 hover:shadow-lg hover:shadow-red-900/20"
                >
                  {/* Player Image */}
                  <div className="aspect-square overflow-hidden bg-gray-800">
                    <PlayerPhoto player={player} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>

                  {/* Info */}
                  <div className="p-4">
                    <span className="text-red-500 text-xs font-semibold uppercase tracking-wider">
                      {player.division}
                    </span>
                    <h3 className="text-white font-bold text-lg mt-1 group-hover:text-red-400 transition-colors">
                      {player.name}
                    </h3>
                    <p className="text-gray-500 text-sm mt-1">{player.country}</p>
                    <p className="text-gray-600 text-xs mt-2 uppercase tracking-wide">
                      {player.specialization}
                    </p>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </section>
    </main>
  );
}

export default WarzoneRosterPage;
